// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 1H5V23H19V1ZM13.0039 17V19.0039H11V17H13.0039Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 19L4 5H2V19H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 19V5H20V19H22Z"}}]};

const MobileVibrateFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-vibrate-filled',
    ref,
    icon: element,
  },
));

MobileVibrateFilledIcon.displayName = 'MobileVibrateFilledIcon';

export default MobileVibrateFilledIcon;
